<template>
	<div class="extend_unit animate__animated animate__fadeIn">
		<div class="unit">
			<div class="row-title">项目信息</div>
			<div class="unit_box">
				<div class="unit_list">
					<div class="row-one">
						<div class="row-item">参数说明</div>
						<div class="row-item">参数值</div>
					</div>
					<div class="row">
						<div class="row-item">项目分类</div>
						<div class="row-item"><input type="text" class="input_box" v-model="formData.project_type" /></div>
					</div>
					<div class="row">
						<div class="row-item">项目负责人</div>
						<div class="row-item">
							<el-select v-model="formData.fz_person" class="select_box" :popper-append-to-body="false" @change="fnSelectPerson" filterable placeholder="请选择">
								<el-option label="请选择" value></el-option>
								<el-option v-for="item in personnelList" :key="item.id" :label="item.name" :value="item.name"></el-option>
							</el-select>
						</div>
					</div>
					<div class="row">
						<div class="row-item">总包单位</div>
						<div class="row-item"><input type="text" class="input_box" v-model="formData.zb_unit" /></div>
					</div>
					<div class="row">
						<div class="row-item">建设单位</div>
						<div class="row-item"><input type="text" class="input_box" v-model="formData.construction_unit" /></div>
					</div>
					<div class="row">
						<div class="row-item">设计单位</div>
						<div class="row-item"><input type="text" class="input_box" v-model="formData.sj_unit" /></div>
					</div>
					<div class="row">
						<div class="row-item">监理单位</div>
						<div class="row-item"><input type="text" class="input_box" v-model="formData.jl_unit" /></div>
					</div>
					<div class="row">
						<div class="row-item">勘察单位</div>
						<div class="row-item"><input type="text" class="input_box" v-model="formData.kc_unit" /></div>
					</div>
					<div class="row">
						<div class="row-item">建筑面积</div>
						<div class="row-item">
							<input type="text" class="input_box" v-model="formData.project_area" />
							(平方米)
						</div>
					</div>
                    <div class="row">
                    	<div class="row-item">项目开工日期</div>
                    	<div class="row-item">
                            <el-date-picker value-format="yyyy-MM-dd" v-model="formData.start_time" type="date" placeholder="选择日期"></el-date-picker>
                    	</div>
                    </div>
				</div>
				<div class="unit_list">
					<div class="row-one">
						<div class="row-item">参数说明</div>
						<div class="row-item">参数值</div>
					</div>
					<div class="row">
						<div class="row-item">建筑层数</div>
						<div class="row-item"><input type="text" class="input_box" v-model="formData.project_layer" /></div>
					</div>
					<div class="row">
						<div class="row-item">建筑高度</div>
						<div class="row-item">
							<input type="text" class="input_box" v-model="formData.project_height" />
							(米)
						</div>
					</div>
					<div class="row">
						<div class="row-item">区域地址</div>
						<div class="row-item">
                            <el-cascader placeholder="请选择项目所在地" :options="options" v-model="formData.region_addr" filterable></el-cascader>
                        </div>
					</div>
					<div class="row">
						<div class="row-item">项目地址</div>
						<div class="row-item"><input type="text" class="input_box" v-model="formData.address" /></div>
					</div>
					<div class="row">
						<div class="row-item">项目经度</div>
						<!-- <div class="row-item"><input type="text" class="input_box" v-model="formData.lng" /><a href="https://lbs.amap.com/console/show/picker" style="font-size: 12px;color: #0080FF;display: inline-block;" target="_blank"> (坐标拾取) </a></div> -->
						<div class="row-item"><input type="text" class="input_box" v-model="formData.lng" /><a href="javascript:void(0);" @click="showMap=true" style="font-size: 12px;color: #0080FF;display: inline-block;"> (坐标拾取) </a></div>
					</div>
					<div class="row">
						<div class="row-item">项目纬度</div>
						<div class="row-item"><input type="text" class="input_box" v-model="formData.lat" /></div>
					</div>
					<div class="row">
						<div class="row-item">合同签订日期</div>
						<div class="row-item">
							<el-date-picker value-format="yyyy-MM-dd" v-model="formData.sign_date" type="date" placeholder="选择日期"></el-date-picker>
						</div>
					</div>
					<div class="row">
						<div class="row-item">签约合同价</div>
						<div class="row-item">
							<input type="text" class="input_box" v-model="formData.project_price" />
							(万元)
						</div>
					</div>
                    <div class="row">
                    	<div class="row-item">计划竣工日期</div>
                    	<div class="row-item">
                            <el-date-picker value-format="yyyy-MM-dd" v-model="formData.end_time" type="date" placeholder="选择日期"></el-date-picker>
                    	</div>
                    </div>
				</div>
			</div>
			<div class="unit_box" v-if="!isXyzShow"><div class="search-btn" @click="fnEditExtendInfo" type="primary"><span>保 存</span></div></div>
		</div>
        <div class="dialog_setMap" v-if="showMap">
            <el-dialog :custom-class="'animate__animated animate__fadeIn'" top="20vh" :close-on-click-modal="false" :modal="false" title="获取经纬度" :visible.sync="showMap" center>
                <div class="show_map">
                    <GDMaps @fnGetLocation="fnGetLocation"></GDMaps>
                </div>
                <div slot="footer" class="dialog-footer">
                    <div class="btn_line">
                        <div class="btn_box red" @click="showMap=false"><span>关 闭</span></div>
                        <div class="btn_box" @click="fnGetLocationYes"><span>确 定</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>
	</div>
</template>

<script>
import { fnRequestPlatform } from '@/utils/upload';
import APP from '@/utils/base';
import request from '@/utils/request';
import { getUserInfo, setUserInfo } from '@/utils/auth.js'
import {regionData, CodeToText} from 'element-china-area-data'
import GDMaps from '@/components/Map/location.vue'
export default {
	data() {
		return {
            options: regionData,
            city: '',
			formData: {
				project_type: '', //项目分类
				fz_person: '', // 项目负责人
				photo: '', // 项目负责人头像
				zb_unit: '', // 总包单位
				construction_unit: '', // 建设单位
				sj_unit: '', // 设计单位
				jl_unit: '', // 监理单位
				kc_unit: '', // 勘察单位
				project_area: '', //建筑面积
                start_time: '',// 项目开工日期
				project_layer: '', // 建筑层数
				project_height: '', // 建筑高度
				region_addr: '', // 区域地址
				address: '', // 项目地址
				lng: '', // 项目经度
				lat: '', // 项目纬度
				sign_date: '', // 合同签订日期
				project_price: '' ,// 签约合同价
                end_time: '',// 计划竣工日期
			},
			personnelList: [] ,// 项目下人员列表
            showMap: false,// 地图坐标拾取
            mapInfo:{
                lng: '',
                lat: '',
            },
            isXyzShow:false
		};
	},
    components: {
        GDMaps
    },
	created() {
        this.isXyzShow = getUserInfo().is_xyz ? true : false
		this.fnInit();
	},
	methods: {
		// 初始化函数
		fnInit() {
			this.fnGetExtendInfo();
			this.fnGetAllPersonnel();
		},
		// 获取扩展信息
		fnGetExtendInfo() {
			request({
				url: 'project/getProjectExtend',
				method: 'GET'
			})
				.then(res => {
					if (res.data) {
                        let _data = res.data
                        for(let i in this.formData){
                            if((i == 'sign_date'||i == 'start_time'||i == 'end_time') && _data[i] == '0000-00-00 00:00:00'){
                                _data[i] = null
                            }
                            if(i == 'region_addr'){
                                console.log(getUserInfo().city);
                                let _city = getUserInfo().city?JSON.parse(getUserInfo().city):''
                                _data[i] = _city?_city.code.split(','):''
                            }
                            this.formData[i] = _data[i]
                        }
					}
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 编辑扩展信息
		fnEditExtendInfo() {
            let _duration = ''
            if(this.formData.start_time != '' && this.formData.end_time != ''){
                _duration = this.getDaysBetween(this.formData.start_time,this.formData.end_time)
            }
            this.formData.duration = _duration
            let _data = JSON.parse(JSON.stringify(this.formData))
            _data.project_id = getUserInfo().id
            // _data.region_addr = _data.region_addr.join(',')
            _data.region_addr = CodeToText[_data.region_addr[0]] + CodeToText[_data.region_addr[1]] + CodeToText[_data.region_addr[2]]
			request({
				url: 'project/editProjectExtend',
				method: 'POST',
				data: _data
			})
				.then(res => {
                    this.fnSaveProject()
					this.$message.success(res.data);
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
        fnSaveProject(){
            let _city = null
            if (this.formData.region_addr) {
              _city = {
                name: CodeToText[this.formData.region_addr[0]] + CodeToText[this.formData.region_addr[1]] + CodeToText[this.formData.region_addr[2]],
                code: this.formData.region_addr.join(',')
              }
            }
            let _obj = {
                company_name: getUserInfo().company_name,
                company_logo: getUserInfo().company_logo,
                city: _city ? JSON.stringify(_city) : _city
            }
            request({
              url: 'project/editProject',
              method: 'POST',
              data: _obj
            }).then(res => {
                let userInfo = getUserInfo()
                userInfo.city = _city ? JSON.stringify(_city) : _city
                setUserInfo(userInfo)
            }).catch(err => {
              this.$message.error(err.data)
            })
        },
        // 计算项目工期
        getDaysBetween(dateString1,dateString2){
           let startDate = Date.parse(dateString1);
           let endDate = Date.parse(dateString2);
           let days=(endDate - startDate)/(1*24*60*60*1000);
           return  days;
        },
		// 获取项目下所有人员
		fnGetAllPersonnel() {
			request({
				url: 'personnel/getAllPersonnel',
				method: 'GET'
			})
				.then(res => {
					this.personnelList = res.data;
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 选择的项目负责人的头像
		fnSelectPerson(e) {
			for (let i in this.personnelList) {
				if (this.personnelList[i].name == e) {
					this.formData.photo = this.personnelList[i].photo;
				}
			}
		},
        // 跳转坐标拾取 子传父
        fnGetLocation(lng,lat){
            this.mapInfo.lng = lng
            this.mapInfo.lat = lat
        },
        // 确认选择的经纬度 关闭弹窗
        fnGetLocationYes(){
            this.formData.lng = this.mapInfo.lng
            this.formData.lat = this.mapInfo.lat
            this.showMap = false
        },
	}
};
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.extend_unit {
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;
	.unit {
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
		// @include flex-box(center, center);
	}
}
.unit_box {
	width: 100%;
	margin: 20px 0;
	@include flex-box(center, start);
}
.row-title {
	width: 100%;
	font-size: 25px;
	padding: 10px;
	@include flex-box(center, center);
}
.unit_list {
	width: 600px;
	margin: 0 20px;
	@include flex-box(center, center, column);
	.row-one {
		background: url(../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		width: 600px;
		height: 40px;
		line-height: 40px;
		@include flex-box(center, center);
		.row-item {
			width: 300px;
			text-align: center;
			color: rgba(255, 255, 255, 0.8);
			&:nth-child(1) {
				width: 180px;
				margin-right: 20px;
			}
			&:nth-child(2) {
				width: 346px;
			}
		}
	}
	.row {
		width: 546px;
		height: 60px;
		line-height: 60px;
		border-bottom: 1px dashed #1d4495;
		color: rgba(255, 255, 255, 0.8);
		@include flex-box(center, center);
		.row-item {
			height: 60px;
			line-height: 60px;
			text-align: center;
			&:nth-child(1) {
				width: 180px;
				margin-right: 20px;
			}
			&:nth-child(2) {
				text-align: left;
				width: 346px;
			}
			.input_box {
				background-color: rgba(77, 180, 244, 0.2);
				width: 260px;
				height: 30px;
				line-height: 40px;
				padding-left: 15px;
				color: rgba(77, 180, 244, 0.7);
				font-size: 12px;
				border-radius: 2px;
				outline: none;
				border: none;
				&::-webkit-input-placeholder {
					color: rgba(77, 180, 244, 0.7);
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: rgba(77, 180, 244, 0.7);
				}
			}
			.select_box {
				width: 260px;
				height: 30px;
				line-height: 30px;
				border-radius: 2px;
			}
		}
		>>> .el-input__inner {
			width: 260px;
			height: 30px;
			border-radius: 2px;
			border: none;
			color: rgba(77, 180, 244, 0.7);
			background-color: rgba(77, 180, 244, 0.2);
			&::-webkit-input-placeholder {
				color: rgba(77, 180, 244, 0.7);
			}
			&::-moz-placeholder {
				/* Mozilla Firefox 19+ */
				color: rgba(77, 180, 244, 0.7);
			}
			&:-moz-placeholder {
				/* Mozilla Firefox 4 to 18 */
				color: rgba(77, 180, 244, 0.7);
			}
			&:-ms-input-placeholder {
				/* Internet Explorer 10-11 */
				color: rgba(77, 180, 244, 0.7);
			}
		}
		>>> .el-select__caret {
			color: rgba(77, 180, 244, 0.7);
		}
		>>> .el-select-dropdown {
			background-color: rgba(9, 17, 32, 1);
			border: 1px solid rgba(77, 180, 244, 1);
		}
		>>> .popper__arrow {
			border-bottom-color: rgba(77, 180, 244, 1) !important;
		}
		>>> .el-select-dropdown__item {
			color: rgba(77, 180, 244, 0.7);
		}
		>>> .el-select-dropdown__item:hover {
			color: #409eff;
		}
		>>> .el-select-dropdown__item.hover {
			color: #409eff;
		}
		>>> .el-input__icon {
			color: rgba(77, 180, 244, 0.7);
		}
		&:last-child {
			border: none;
		}
	}
}
.dialog_setMap{
    >>>.el-dialog {
    	width: 720px;
        height: 620px;
        background-color: rgba(9, 17, 32, 1);
        border: 1px solid rgba(58,116,221,1);
    }
    >>>.el-dialog__body{
      padding: 10px;
      height: 510px;
    }
    >>>.el-form-item__label{
    	color: #4DB4F4;
    }
    >>>.el-dialog__title{
    	color: #4DB4F4;
    }
    >>>.el-dialog__close{
    	color: #4DB4F4;
    }
    .btn_line{
        @include flex-box(center,center);
    }
    .btn_box{
    	width: 80px;
    	height: 32px;
    	background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
    	background-size: 100% 100%;
    	color: #FFFFFF;
    	font-size: 14px;
    	cursor: pointer;
    	@include flex-box(center,center);
    	span{
    		margin-top: -5px;
    	}
        &.red{
        	background: url(../../../assets/img/btn_bg_rsm.png) no-repeat;
        	background-size: 100% 100%;
        }
    }
    .show_map{
        width: 700px;
        height: 490px;
        z-index: 100;
        overflow: hidden;
        color: #4DB4F4;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/ProjectExtend/projectExtendDefault/index.vue